module.exports = __webpack_public_path__ + "img/dianlifuzai-power_load-fill.5e5a7bf9.png";